import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import { ElementDefinition, TextElement } from "@easy-email-pro-core/typings";
import { BasicBlock } from "@easy-email-pro-core/components";
import React from "react";

const defaultData: ElementDefinition<TextElement>["defaultData"] = {
  attributes: {
    align: "left",
    color: "#000000",
    "font-family": "Ubuntu, Helvetica, Arial, sans-serif",
    "font-size": "13px",
    "line-height": "1",
    padding: "10px 25px",
    "padding-top": "10px",
    "padding-right": "25px",
    "padding-bottom": "10px",
    "padding-left": "25px",
    "letter-spacing": "0px",
  },
  data: {},
};

export const Text = createBlock<TextElement>({
  get name() {
    return t("Text");
  },
  defaultData,
  type: BasicType.TEXT,
  create: (payload) => {
    const defaultData: TextElement = {
      type: BasicType.TEXT,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.TEXT,
  render(params) {
    return <BasicBlock params={params} tag="mj-text" />;
  },
});
